module.exports = __webpack_public_path__ + "img/merchants.3b9a1966.svg";